// extracted by mini-css-extract-plugin
module.exports = {"load-shedding":"LoadShedding_load-shedding__KpqKy"};